// The order group accommodation results arrive in. The hub orders them by total price (the
// page is a slice of the whole priced set, so only the hub can order it truthfully).
//
// Cheapest first unless the agent chooses otherwise. It used to be dearest first: the first
// page of a search for 30 guests in Marbella opened on combinations at USD 230,000 to
// 260,000 while pairs at USD 24,000 sat at the far end.
export const DEFAULT_CLUSTER_SORT = "priceAsc";

/** What to ask the hub for: the agent's own choice when it is a price order, else the default. */
export const serverClusterSort = (clusterSort) =>
  clusterSort === "priceDesc" || clusterSort === "priceAsc" ? clusterSort : DEFAULT_CLUSTER_SORT;
